import React from 'react'

import img1 from "./image1.jpeg"
import img2 from "./image2.jpeg"
import img3 from "./image3.jpeg"
import img4 from "./image4.jpeg"
import img5 from "./image5.jpeg"
import img6 from "./image6.jpeg"

function gallery() {
  return (
    <div className="container my-5">
        <div className="container">
        
                    {/* <h1 className='text-center' style={{color: "#4437B8"}}> <strong>INTERNATIONAL CONFERENCE ON INTELLIGENT COMPUTING AND COMMUNICATION TECHNIQUES</strong> </h1>
                    <h1 className='text-center' style={{color: "#4437B8"}}> <strong>2024</strong> </h1> */}
        
                <div className="row my-5">
                    <div className="col-md-4 mt-3 col-lg-4">
                        <img src={img1} className="img-fluid" alt="image" />
                    </div>
                    <div className="col-md-4 mt-3 col-lg-4">
                        <img src={img2} className="img-fluid" alt="image" />
                    </div>
                    <div className="col-md-4 mt-3 col-lg-4">
                        <img src={img3} className="img-fluid" alt="image" />
                    </div>
                    <div className="col-md-4 mt-3 col-lg-6">
                        <img src={img4} className="img-fluid" alt="image" />
                    </div>
                    <div className="col-md-4 mt-3 col-lg-6">
                        <img src={img5} className="img-fluid" alt="image" />
                    </div>
                    <div className="col-md-4 mt-3 col-lg-6">
                        <img src={img6} className="img-fluid" alt="image" />
                    </div>
                    <div className="col-md-4 mt-3 col-lg-6">
                        <img src={img3} className="img-fluid" alt="image" />
                    </div>
        
                </div>
            </div>
    </div>
  )
}

export default gallery